import React, {useState,useEffect} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ArrowRightIcon from '@mui/icons-material/ArrowRightAlt';
import KbinConfirm from './KbinConfirm';
import BottomButtons from './BottomButtons';
import {Inc,Owner,KbinColabo} from './Inc';
import Ajax from './Ajax';
import Toast from './Toast';
//import Success from './Success';
import Title from './Title';
import Loading from './Loading';

interface KbinInputProps {
	owner:Owner,
}

//let isThanks = false;

const KbinInput = (props:KbinInputProps)=> {
	const classes = useStyles();

    const defValues:KbinColabo = {
		jiki: "",
		title: "",
		artists: "",
        memo: "",
		banner: "9",
		target: "9",
    }
    const [states, setStates] = useState({
		values: defValues,
        isLoading: false,
        isConfirm: false,
        isSuccess: false,
	});
    const [toast,setToast] = useState("");

    const handleModalClose = ()=>{
		setStates({...states,"isConfirm":false});
	};

	const handleChange = (name: keyof KbinColabo) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setStates({ ...states, values:{...states.values,[name]: event.target.value }});
	};
	const handleChangeRadio = (name: keyof KbinColabo) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setStates({ ...states, values:{...states.values,[name]: event.target.value }});
	};	

	const closeToast = ()=>{
        setToast("");
	}
    const validate = ()=>{
		const memo = states.values.memo.trim();
		if( memo==='' ){
			setToast("コラボ内容の説明を入力してください。");
		} else {
        	setStates({...states,"isConfirm":true});
		}
    }
    const send = ()=>{
        setStates({...states,"isLoading":true});
		Ajax.setEditorId(props.owner.owner_id);
        Ajax.send("kbin/send",states.values,(res:any)=>{
            if( res.ok ){
                //isThanks = true;
                setStates({values:defValues,"isLoading":false,"isConfirm":false,"isSuccess":true});
                window.scrollTo(0, 0);
            } else {
                setStates({...states,"isLoading":false,"isConfirm":false,"isSuccess":false});
                setToast("送信に失敗しました。");
            }
        });
        
    }
    useEffect( ()=>{
        //isThanks = false;
		//isThanks = true;
		//setFlags({"isLoading":false,"isConfirm":false,"isSuccess":false});
		setStates({...states,"isLoading":false,"isConfirm":false,"isSuccess":false});
        window.scrollTo(0,0);
    },[]);

	//if( props.owner.owner_id===0 ){
	//	return <Redirect to="/profile"/>
	//}

	return (
		<div className={classes.root+" "+classes.policy}>
			{states.isSuccess ? (
				<Paper className={classes.paper}>
					<div style={{marginBottom:"3em"}}>
						<Title text="Ｋ便鉄道コラボのご相談をうけたまわりました。" size={2}/>
						<div className={classes.section}>
							<p><b>store@retro-biz.com</b>から確認メールを送信いたしました。</p>
							<p>
								担当者が予定を確認した上で予約確定となります。<br/>
								なるべく早めに返信いたしますので今しばらくお待ち下さい。（通常１営業日以内）
							</p>
						</div>
					</div>
				</Paper>
			):(
			<React.Fragment>
				<Paper className={classes.paper}>
					<Title text="Ｋ便鉄道コラボ" size={1} icon="store"/>
					<div>
						<img src="https://58yy5w7p.user.webaccel.jp/img/default/kbin/kbin_colabo.png" style={{width:'100%'}}/>
					</div>
					<div style={{marginBottom:"4em"}}>
						<p>架空ストアで常時開催している「架空のＫ便鉄道」では、コラボレーションの提案を募集しています。<br/>
						主催イベントでのお得な通販対応から作品の魅力を再発見するテーマに沿った作品ラインナップの提案まで柔軟に対応いたしますので、まずは気軽にご相談ください。</p>
					</div>
					<div style={{marginBottom:"4em"}}>
						<h2 style={{marginBottom:'1em'}}>
							<Stack direction="row" spacing={2}>
								<ContactSupportIcon/>
								架空のＫ便鉄道とは？
							</Stack>
						</h2>
						<div style={{marginBottom:"1em"}}>
							送料と支払手数料が無料になるキャンペーンです。<br/>
							対象商品がご注文に一つでも入っていれば、送料も支払手数料も無料（架空ストア負担）になります。<br/>
							通常ではだいたい３０作品前後が対象で、毎週金曜日に入れ替えています。<br/>
						</div>
						<div style={{textAlign:'right'}}>
							<a href="https://store.retro-biz.com/item_kbin.html" target="_blank" rel="noopener noreferrer"><Button variant="text" color="primary"><ArrowRightIcon/> 現在の対象商品はこちら</Button></a>
						</div>
					</div>
					<div style={{marginBottom:"4em"}}>
						<h2 style={{marginBottom:'1em'}}>
							<Stack direction="row" spacing={2}>
								<ContactSupportIcon/>
								どんなコラボが可能？
							</Stack>
						</h2>
						<div style={{marginBottom:"1em"}}>
							例えば同人誌イベントの開催期間中に、そのイベントに参加している作家さんの全作品をＫ便鉄道の対象とすることで、送料や手数料を気にすることなくお客さんが作品を購入することができます。<br/>
							架空ストアでは複数の作家さんの作品を一緒に購入できますし、こうしたイベントにはうってつけです。<br/>
						</div>
						<div style={{marginBottom:"1em"}}>
							また、特にイベントがなくても、「渾身の新作が完成したのでリリースと同時に旧作品をＫ便鉄道の対象にしたい」というようなご要望にも対応できます。<br/>
						</div>
						<div style={{marginBottom:"2em"}}>
							ポストカード作家さんの作品ばかりを並べてみたいですとか、自分のデビュー１周年を祝ってほしい、夏なので海にちなんだ作品でチームを組んでみたいなど、テーマを掲げた上で作品ラインナップを提案していただくのも良いですね。<br/>
						</div>
					</div>
					<div style={{marginBottom:"2em"}}>
						<h2 style={{marginBottom:'1em'}}>
							<Stack direction="row" spacing={2}>
								<ContactSupportIcon/>
								開催期間・作品数の目安
							</Stack>
						</h2>
						<div style={{marginBottom:"2em"}}>
							以下の表の内容は、あくまで目安です。<br/>
							極端に長い開催期間や膨大な作品数などでない限りはご相談に応じます。<br/>
						</div>
					</div>
					<table style={{marginBottom:"0em"}} className="visitTimeTable">
						<tbody>
						<tr>
							<th colSpan={2}>架空のＫ便鉄道　目安</th>
						</tr>
						<tr>
							<td className='week'>開催期間</td>
							<td>7日間（金曜日から木曜日まで）</td>
						</tr>
						<tr>
							<td className='week'>作品数</td>
							<td>10～100作品程度</td>
						</tr>
						<tr>
							<td className='week'>作家数</td>
							<td>1人以上</td>
						</tr>
						<tr>
							<td className='week'>バナー画像<span style={{color:'brown'}}>※</span></td>
							<td>架空ストアが作成</td>
						</tr>
						</tbody>
					</table>
					<div style={{fontSize:'90%',marginBottom:'2em'}}>
						※このページの一番上や架空ストアのトップページにあるような画像<br/>
					</div>
					<div style={{marginBottom:"4em"}}>
					・コラボの提案者が参加していないイベントやコラボの提案者の作品が対象となっていないご提案はお断りいたします。<br/>
					・原則として対象作品は開催期間の前日までに架空ストアへの納品手続きを済ませてください。<br/>
					・架空ストアに作家登録されていない作家さんの作品を対象とすることはできません。<br/>
					・バナー画像は自由に作成していただくことも可能です。画像のサイズや締め切りなどは別途お問い合わせ下さい。<br/>
					</div>

					<div style={{marginBottom:"8em"}}>
						<h2 style={{marginBottom:'1em'}}>
							<Stack direction="row" spacing={2}>
								<ContactSupportIcon/>
								共同企画者の紹介と注意事項
							</Stack>
						</h2>
						<div style={{marginBottom:"1em"}}>
							コラボを提案してくれた作家さんは、「共同企画者」としてＫ便鉄道のページに掲載いたします。<br/>
							企画についての説明や挨拶なども掲載したい場合は、開催期間の前日までにテキストをお送り下さい。<br/>
						</div>
						<div style={{marginBottom:"2em",color:'brown',backgroundColor:'#FFEEEE',padding:'1em'}}>
							・コラボの提案は無料です。共同企画者に対してコラボの利用料金等を請求することはありません。<br/>
							・やむをえない事情でコラボが中止になった場合、架空ストアも共同企画者も互いに責を問わないものとします。<br/>
							・コラボの提案やテキストおよび画像の作成に対して架空ストアから謝礼報酬の支払いはできませんのであしからずご了承下さい。<br/>
						</div>
					</div>


					<Divider/>
					<div style={{marginBottom:"2em"}}>
						<div style={{marginBottom:"2em"}}/>
						<h2 style={{marginBottom:'1em'}}>
							<Stack direction="row" spacing={2}>
								<LocalShippingIcon/>
								Ｋ便鉄道コラボのご相談窓口
							</Stack>
						</h2>
						{props.owner.owner_id>0 ? (
						<Grid container spacing={2}>
							<Grid item xs={12} sm={12}>
								<FormControl className={classes.formControl} fullWidth={true} required={false} error={states.values.memo===""}>
									<FormLabel component="label" className={classes.formLabel}>コラボ内容の説明<span className="formRequired">必須</span></FormLabel>
									<TextField
										id="kbincolabo_memo"
										fullWidth
										multiline
										rows="8"
										value={states.values.memo}
										onChange={handleChange('memo')}
										className={classes.textfield}
										margin="normal"
										variant="outlined"
									/>
									<FormHelperText>※上記の説明を参考にイベントやテーマについて自由に書いてください</FormHelperText>
								</FormControl>
							</Grid>

							<Grid item xs={12} sm={12} style={{color:'brown'}}>
								以下は現時点でわかる範囲で入力してください。見込みや予定で構いません
							</Grid>

							<Grid item xs={12} sm={12}>
								<FormControl className={classes.formControl} fullWidth={true} required={false}>
									<FormLabel component="label" className={classes.formLabel}>イベント名<span className="formLabelHelper">（イベントとのコラボの場合）</span></FormLabel>
									<TextField
										id="kbincolabo_title"
										fullWidth
										value={states.values.title}
										onChange={handleChange('title')}
										className={classes.textfield}
										margin="normal"
										variant="outlined"
									/>
								</FormControl>
							</Grid>

							<Grid item xs={12} sm={12}>
								<FormControl className={classes.formControl} fullWidth={true} required={false}>
									<FormLabel component="label" className={classes.formLabel}>開催時期</FormLabel>
									<TextField
										id="kbincolabo_jiki"
										fullWidth
										multiline
										rows="4"
										value={states.values.jiki}
										onChange={handleChange('jiki')}
										className={classes.textfield}
										margin="normal"
										variant="outlined"
									/>
									<FormHelperText>※年末ごろ、5月中旬などのざっくりとした予定でも構いません</FormHelperText>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={12}>
								<FormControl className={classes.formControl} fullWidth={true} required={false}>
									<FormLabel component="label" className={classes.formLabel}>参加作家さん</FormLabel>
									<TextField
										id="kbincolabo_artists"
										fullWidth
										multiline
										rows="4"
										value={states.values.artists}
										onChange={handleChange('artists')}
										className={classes.textfield}
										margin="normal"
										variant="outlined"
									/>
									<FormHelperText>※現時点で参加が見込まれる作家さんの名前もしくはおおよその人数</FormHelperText>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={12}>
								<FormControl className={classes.formControl} fullWidth={true} required={false}>
									<FormLabel component="label" className={classes.formLabel}>対象作品</FormLabel>
									<Box style={{padding:'0.5em'}}>
									<RadioGroup
										aria-labelledby="radio-kbincolabo-target"
										defaultValue={states.values.target}
										name="radio-kbincolabo-target"
										onChange={handleChangeRadio('target')}
									>
										<FormControlLabel value={Inc.kbincolabotargets[0].id} control={<Radio />} label={Inc.kbincolabotargets[0].label}/>
										<FormControlLabel value={Inc.kbincolabotargets[1].id} control={<Radio />} label={Inc.kbincolabotargets[1].label}/>
										<FormControlLabel value={Inc.kbincolabotargets[2].id} control={<Radio />} label={Inc.kbincolabotargets[2].label}/>
									</RadioGroup>
									</Box>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={12}>
								<FormControl className={classes.formControl} fullWidth={true} required={false}>
									<FormLabel component="label" className={classes.formLabel}>バナーの作成</FormLabel>
									<Box style={{padding:'0.5em'}}>
									<RadioGroup
										aria-labelledby="radio-kbincolabo-banner"
										defaultValue={states.values.banner}
										name="radio-kbincolabo-banners"
										onChange={handleChangeRadio('banner')}
									>
										<FormControlLabel value={Inc.kbincolabobanners[0].id} control={<Radio />} label={Inc.kbincolabobanners[0].label}/>
										<FormControlLabel value={Inc.kbincolabobanners[1].id} control={<Radio />} label={Inc.kbincolabobanners[1].label}/>
										<FormControlLabel value={Inc.kbincolabobanners[2].id} control={<Radio />} label={Inc.kbincolabobanners[2].label}/>
									</RadioGroup>
									</Box>
								</FormControl>
							</Grid>
						</Grid>
						):(
						<Box>
							ご相談窓口のご利用には作家登録が必要です<br/>
							作家登録が済んでいる場合は、ログインをして下さい<br/>
							<div style={{textAlign:'right'}}>
								<Link to="/profile"><Button variant="text" color="primary"><ArrowRightIcon/> 作家登録をする</Button></Link>
							</div>
						</Box>
						)}
					</div>
					{props.owner.owner_id>0 && <BottomButtons button1='内容の確認' onClick1={validate}/>}
				</Paper>
			</React.Fragment>
			)}          
			<KbinConfirm send={send} close={handleModalClose} isOpen={states.isConfirm} values={states.values}/>
			<Toast close={closeToast} mes={toast}/>
			<Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default KbinInput;
